/**
 * Общий модуль для всех лисалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function() {
    // Локальные переменные
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;


    /**
     * Вызов всех функций, которые были добавлены
     * в массив queue в процессе загрузки библиотеки
     * (до этого момента их вызов привёл бы к ошибке).
     */
    var initQueue = function() {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };


    /**
     * Загрузить библиотеку и выполнить
     * отложенные функции из массива queue.
     */
    var loadAndInit = function() {
        var f = function() {
            libraryLoaded = true;
            initQueue();
        };

        // Случай, если библиотека вдруг уже загружена
        // (например, если она принудительна вставлена в html через <script>)
        itsoftApp.loadStyle("/assets/scripts/swiper/swiper.min.css");
        itsoftApp.loadScript("/assets/scripts/swiper/swiper.min.js", function() {
            DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
            f();
        });
    };


    /**
     * Добавление переданной функции в очередь на выполнение,
     * либо немедленное исполнение функции, если библиотека уже загружена.
     *
     * @param {function} func
     */
    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };


    // Доступ к функциям
    // текущего модуля
    module.addEvent = addEvent;

    var setSlider = function (el, name, currentSlide) {
        var createSlider = function () {
            var BREAKPOINT = {
                mobile: 320,
                tablet: 768,
                "tablet-max": 1024,
                desktop: 1280
            }

            var sliderContainer = el.querySelector(".swiper-container");
            var navigation = el.querySelector(".js-navigation");
            var thumbNavigation = el.querySelector(".js-thumb-navigation");
            var pagination = el.querySelector(".js-pagination");
            var slideCount = el.getAttribute("data-slide-count");
            var dataDevice = el.getAttribute("data-destroy-device");
            var freeMode = el.getAttribute("data-free-mode");
            var autoplay = el.hasAttribute("data-autoplay");
            var dataGap = el.getAttribute("data-gap");
            var columns = el.getAttribute("data-mobile-columns");
            var columnsScrollbar = el.getAttribute("data-mobile-columns-scrollbar");
            var initialSlide = el.getAttribute("data-initial-slide");
            var thumbnails = el.querySelector(".gallery-thumbs");
            var directionFromTablet = el.getAttribute("data-direction-from-tablet");
            var direction = el.getAttribute("data-direction");
            var centered = el.getAttribute("data-slides-centered");
            var toTabletSettings = el.getAttribute("data-slider-to-tablet");
            var fromTabletSettings = el.getAttribute("data-vertical-from-tablet");
            var isTabs = sliderContainer.classList.contains("page__tabs");
            var isInitialized = false;
            var initializedSlider;
            var loopStatus = el.hasAttribute("data-loop");

            if (name) {
                var sliderName = name;
            }

            var sliderSettings = {
                slidesPerView: "auto",
                watchOverflow: true,
                a11y: {
                    firstSlideMessage: "",
                    lastSlideMessage: ""
                },
                on: {}
                // effect: "fade",
                // fadeEffect: {
                //     crossFade: true
                // }
            }

            var destroySlider = function (currentSlider) {
                currentSlider.destroy(false, true);
                initializedSlider = undefined;
                // isInitialized = false;
            }

            var initSlider = function (currentSlider) {
                initializedSlider = new Swiper(sliderContainer, sliderSettings);
                // return initializedSlider;

                // if (initializedSlider) {
                //     if (sliderName) {
                //         module.slider[sliderName] = initializedSlider;
                //     }

                //     if (currentSlide) {
                //         initializedSlider.slideTo(+currentSlide);
                //     }

                //     isInitialized = true;
                // }
            }

            var onWindowResize = function () {
                if (itsoftApp.utils.getViewportSize() >= BREAKPOINT[dataDevice]) {
                    if (isInitialized === true) {
                        destroySlider();
                    }
                } else {
                    if (isInitialized === false) {
                        initSlider();
                    }
                }
            }

            if (navigation) {
                var prevBtn = navigation.querySelector(".js-prev-btn");
                var nextBtn = navigation.querySelector(".js-next-btn");

                sliderSettings.navigation = {};
                sliderSettings.navigation.prevEl = prevBtn;
                sliderSettings.navigation.nextEl = nextBtn;
            }

            if (pagination) {
                sliderSettings.pagination = {};
                sliderSettings.pagination.el = pagination;
                sliderSettings.pagination.type = "fraction";
                sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>' +
                          '/' +
                          '<span class="' + totalClass + '"></span>';
                };
            }

            if (autoplay) {
                var autoplayDelay = el.getAttribute("data-autoplay-delay");
                if (autoplayDelay) {
                    sliderSettings.autoplay = {
                        delay: +autoplayDelay
                    }
                } else {
                    sliderSettings.autoplay = true;
                }
            }

            if (freeMode) {
                sliderSettings.freeMode = true;
            }

            if (slideCount) {
                sliderSettings.slidesPerView = slideCount;
            }

            if (centered) {
                sliderSettings.centeredSlides = true;
                // sliderSettings.centerSlidesBounds = true;
                // sliderSettings.centerInsufficientSlides = true;
                sliderSettings.loop = true;
                // sliderSettings.loopPreventsSlide = false;
                sliderSettings.on.slideChangeTransitionStart = function () {     
                    var $wrapperEl = this.$wrapperEl[0];
                    var params = this.params;
                    var wrapperChildrens = $wrapperEl.querySelectorAll(("." + (params.slideClass) + "." + (params.slideDuplicateClass)));
                    
                    Array.prototype.forEach.call(wrapperChildrens, function (childElement) {
                        var idx = childElement.getAttribute("data-swiper-slide-index");
                        childElement.removeChild(childElement.querySelector("div"));
                        childElement.appendChild($wrapperEl.querySelector('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').querySelector("div").cloneNode(true));
                    });
                }

                sliderSettings.on.slideChangeTransitionEnd = function () {
                    this.slideToLoop(this.realIndex, 0, false);
                }
            }

            if (dataGap) {
                sliderSettings.spaceBetween = +dataGap;
                
                if (!slideCount) {
                    sliderSettings.slidesPerView = "auto";
                }
            }

            if (!loopStatus && !sliderContainer.classList.contains("page__tabs") && !columns && !columnsScrollbar && !centered) {
                var slidesNumber = sliderContainer.querySelectorAll(".swiper-slide").length;
                var visibilitySlidesNumber = sliderContainer.querySelectorAll(".swiper-slide-visible:not(.swiper-slide-duplicate)").length;
                sliderSettings.watchSlidesVisibility = true;
                if (!sliderContainer.classList.contains("gallery-top")) {
                    sliderSettings.on.init = function () {
                        var slidesNumber = sliderContainer.querySelectorAll(".swiper-slide").length;
                        var visibilitySlidesNumber = sliderContainer.querySelectorAll(".swiper-slide-visible:not(.swiper-slide-duplicate)").length;
                        sliderSettings.loop = visibilitySlidesNumber < slidesNumber;
                        sliderSettings.on = undefined;
                        // this.off("init");
                        destroySlider(this);
                        initSlider();
                    }
                }
            }

            if (thumbnails) {
                var thumbsSettings = {
                    slidesPerView: "auto",
                    watchOverflow: true,
                    a11y: {
                        firstSlideMessage: "",
                        lastSlideMessage: ""
                    }
                };


                // if (thumbnails.hasAttribute("data-slide-count")) {
                //     thumbsSettings.slidesPerView = +thumbnails.getAttribute("data-slide-count");
                // }

                if (thumbNavigation) {
                    var prevThumbBtn = thumbNavigation.querySelector(".js-prev-btn");
                    var nextThumbBtn = thumbNavigation.querySelector(".js-next-btn");

                    thumbsSettings.navigation = {};
                    thumbsSettings.navigation.prevEl = prevThumbBtn;
                    thumbsSettings.navigation.nextEl = nextThumbBtn;
                    thumbsSettings.centeredSlides = true,
                    thumbsSettings.loop = true,
                    thumbsSettings.on = {};

                    // if (slideCount) {
                        thumbsSettings.slideThumbActiveClass = "swiper-slide-thumb-active";
                    // }

                    // thumbsSettings.on.slideChangeTransitionStart = function () {
                    //     var $wrapperEl = this.$wrapperEl[0];
                    //     var params = this.params;
                    //     var wrapperChildrens = $wrapperEl.querySelectorAll(("." + (params.slideClass) + "." + (params.slideDuplicateClass)));
                        
                    //     Array.prototype.forEach.call(wrapperChildrens, function (childElement) {
                    //         var idx = childElement.getAttribute("data-swiper-slide-index");
                    //         childElement.removeChild(childElement.querySelector("div"));
                    //         childElement.appendChild($wrapperEl.querySelector('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').querySelector("div").cloneNode(true));
                    //     });
                    // }

                    // thumbsSettings.on.slideChangeTransitionEnd = function () {
                    //     this.slideToLoop(this.realIndex, 0, false);
                    // }
                }

                var galleryThumbs = new Swiper(thumbnails, thumbsSettings);

                sliderSettings.thumbs = {
                    swiper: galleryThumbs,
                }

                sliderSettings.loop = true;

                sliderSettings.on.slideChangeTransitionStart = function () {     
                    var $wrapperEl = this.$wrapperEl[0];
                    var params = this.params;
                    var wrapperChildrens = $wrapperEl.querySelectorAll(("." + (params.slideClass) + "." + (params.slideDuplicateClass)));
                    
                    Array.prototype.forEach.call(wrapperChildrens, function (childElement) {
                        var idx = childElement.getAttribute("data-swiper-slide-index");
                        childElement.removeChild(childElement.querySelector("div"));
                        childElement.appendChild($wrapperEl.querySelector('.' + params.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params.slideDuplicateClass + ')').querySelector("div").cloneNode(true));
                    });
                }

                sliderSettings.on.slideChangeTransitionEnd = function () {
                    this.slideToLoop(this.realIndex, 0, false);
                }

                sliderSettings.simulateTouch = false;
            }

            if (initialSlide) {
                sliderSettings.initialSlide = +initialSlide;
            }

            if (direction) {
                sliderSettings.direction = direction;
                sliderSettings.simulateTouch = false;

                if (direction === "vertical") {
                    sliderSettings.scrollbar = {
                        el: ".swiper-scrollbar",
                        draggable: true
                    }
                }
            }

            if (fromTabletSettings) {
                var dataVerticalFromTablet = el.hasAttribute("data-vertical-from-tablet");
                var dataSlideFromTablet = el.getAttribute("data-slide-from-tablet");

                sliderSettings.breakpoints = {};
                sliderSettings.breakpoints["767"] = {};

                if (directionFromTablet) {
                    sliderSettings.breakpoints["767"].direction = directionFromTablet;
                }
            }

            if (toTabletSettings) {
                var dataSlideCountToTablet = el.getAttribute("data-slide-count-to-tablet");
                var dataGapToTablet = el.getAttribute("data-gap-to-tablet");

                sliderSettings.breakpoints = {};
                sliderSettings.breakpoints["1279"] = {};

                if (dataSlideCountToTablet) {
                    sliderSettings.breakpoints["1279"].slidesPerView = +dataSlideCountToTablet;
                }

                if (dataGapToTablet) {
                    sliderSettings.breakpoints["1279"].spaceBetween = +dataGapToTablet;
                }

                sliderSettings.breakpoints["1279"].initialSlide = 1;
            }

            if (columns) {
                sliderSettings.breakpoints = {
                    480: {
                        slidesPerColumn: 3,
                        slidesPerView: 1,
                        spaceBetween: 16,
                        direction: "horizontal"
                    },

                    767: {
                        slidesPerColumn: 3,
                        slidesPerView: 2,
                        spaceBetween: 16,
                        direction: "horizontal"
                    },

                    9800: {
                        slidesPerColumn: "auto",
                        slidesPerView: "auto"
                    }
                }
            }

            if (columnsScrollbar) {
                sliderSettings.breakpoints = {
                    480: {
                        slidesPerColumn: 3,
                        slidesPerView: 1,
                        direction: "horizontal",
                        spaceBetween: 16,
                        watchSlidesVisibility: true
                    },

                    767: {
                        slidesPerColumn: 3,
                        slidesPerView: 1,
                        direction: "horizontal",
                        spaceBetween: 60,
                        watchSlidesVisibility: true
                    },

                    9800: {
                        slidesPerColumn: "auto",
                        slidesPerView: "auto",
                        direction: "vertical",
                        watchSlidesVisibility: true
                    }
                }
            }

            // if (isTabs) {
            //     sliderSettings = {};
            //     sliderSettings.breakpoints = {
            //         1280: {
            //           slidesPerGroup: 5,
            //           freeMode: false
            //         }
            //     }
            // }

            if (dataDevice) {
                onWindowResize();
                itsoftApp.modules.windowResize.addEvent(onWindowResize);
            } else {
                initSlider();
            }
        }

        if (el.hasAttribute("data-delay")) {
            setTimeout(function () {
                addEvent(createSlider);
            }, +(el.getAttribute("data-delay")));
        } else {
            addEvent(createSlider);
        }
    }

    module.slider = {};
    module.callback = setSlider;
});